import {AppHelper} from "../../appHelper";
import {AppBaseProps, CommonApp, Entity} from "../../core/components/commonApp";
import {SortableTreeNode, Tree} from "../../core/components/sortableTree";
import {ToolBoxCommand} from "../../core/components/sortableTreeSlot";
import {Config} from "../../core/config/config";
import {Helper} from "../../core/util/helper";
import {General} from "../../../siteManagement/general";
import WorkPackageApp, {CapacityRequirementEntity, WorkPackageAppProps} from "../workPackage/workPackage";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {DialogHelper} from "../../core/util/dialogHelper";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {Sheet, SheetEventType} from "../../../siteManagement/sheet";
import ExecutionDialog from "./executionDialog";
import {RecurringTaskInfo} from "../../taskGroup/taskGroup";
import {RecurringTaskEntity, TaskState} from "./recurringTask";
import { WorkPackageEntity } from "../workPackage/workPackage";
import TriggeringErrorListApp, {TriggeringErrorListAppProps, TriggeringErrorListEntity} from "./triggeringErrorList";
import { PageTitleProps } from "../../core/components/pageTitle";
import { EnumEntity, StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export default class RecurringTaskHistoryApp extends React.Component<RecurringTaskHistoryProps, RecurringTaskHistoryState> {

    common = new AppHelper();
    private treeRef: Tree;
    private cancelDialogRef: ExecutionDialog;
    private rescheduleDialogRef: ExecutionDialog;
    private finishDialogRef: ExecutionDialog;
    private sheet: Sheet;
    translations: StringKeyDictionary<string> = null;

    private getRecurringTask = (taskExecutions: Array<ExecutionInfoItem>): Array<ExecutionTreeNode> => {
        let nodes: Array<ExecutionTreeNode> = [];

        taskExecutions.forEach(taskExecution => {
            let node = this.FillExecutionNode(taskExecution);
            nodes.push(node);
        });
        return nodes;
    }

    private getRecurringTaskRoot = (): RecurringTaskRoot => {
        return ({Title: Helper.getTranslation("WebCRM.Tasks.RecurringTask.Executions"), children: this.state.TreeView});
    }

    constructor(props: RecurringTaskHistoryProps) {
        super(props);
        this.common.init(this);
        this.state = {
            DialogText: "",
            TreeView: this.getRecurringTask(props.entity.Executions)
        };

        this.sheet = General.Sheet.Manager.getTopMostSheet();
    }

    private FillExecutionNode = (taskExecution: ExecutionInfoItem): ExecutionNode => {
        let node: ExecutionNode = {
            Type: ExecutionItemType.Execution,
            ExecutionId: taskExecution.ExecutionId,
            ExecutionNo: taskExecution.ExecutionNo,
            ExecutionDate: taskExecution.ExecutionDate,
            ExecutionState: taskExecution.ExecutionState,
            AssignmentCount: taskExecution.Assignments.length,

            StartMin: taskExecution.StartMin,
            EndMax: taskExecution.EndMax,

            StateDate: taskExecution.StateDate,

            StateToolTip: taskExecution.StateToolTip,
            WorkPackageId: taskExecution.WorkPackageId,
            IsScheduled: taskExecution.IsScheduled,
            WorkPackageTitle: taskExecution.WorkPackageTitle,
            SchemaVersion: taskExecution.SchemaVersion,
            CapacityRequirements: taskExecution.CapacityRequirements,
            Assignments: taskExecution.Assignments,
            ErrorCount: taskExecution.ErrorCount,
            collapsed: true,
            children: [],
            FonCli: null
        };

        taskExecution.Assignments.forEach(assignment => {
            let assignmentNode: AssignmentNode = {
                Type: ExecutionItemType.Assignment,
                AssignmentState: assignment.AssignmentState,
                AssignmentStateType: assignment.AssignmentStateType,
                Name: assignment.Name,
                ProjectNo: assignment.ProjectNo,
                Pindex: assignment.Pindex,
                WorkStart: assignment.WorkStart,
                WorkEnd: assignment.WorkEnd,
                ReportCount: assignment.ReportCount,
                ServiceReportCount: assignment.ServiceReportCount,
                Kennung: assignment.Kennung,
                CapacityInMinutes: assignment.CapacityInMinutes,
                DurationInDays: assignment.DurationInDays,
                IsContainerAssignment: assignment.IsContainerAssignment,
                GroupNo: assignment.GroupNo,
                RessNo: assignment.RessNo,
                GroupName: assignment.GroupName,
                children: [],
                parentExecutionState: taskExecution.ExecutionState.Value
            }
            node.children.push(assignmentNode);
        });
        return node;
    }
    private canShowCommand = (type: ToolBoxCommand, node: TreeLineItem, name?: string): boolean => {
        if (!this.props.entity.Task.ExecutionMgmtEnabled)
            return false;
        if (!Helper.hasValue(this.props.entity.Task.LockMessage)) {
            if (type != ToolBoxCommand.Custom) {
                return false;
            } else {
                // Nur bei Auslösungen Aktionen
                if (node.Type === ExecutionItemType.Execution) {
                    let execNode = node as ExecutionNode;
                    if (name == "showErrors" || name == "resetErrors")
                        return execNode.ErrorCount > 0;
                        
                    if (execNode.ExecutionState.Value !== ExecutionState.Finished && execNode.ExecutionState.Value !== ExecutionState.Cancelled) {
                        if (name === "cancel")
                            return true;
                    }
                    if (execNode.ExecutionState.Value !== ExecutionState.Finished && execNode.ExecutionState.Value !== ExecutionState.Cancelled && execNode.Assignments.length === 0) {
                        if (name === "rescheduleExecution")
                            return true;
                    }
                    if ((execNode.ExecutionState.Value === ExecutionState.Triggered || execNode.ExecutionState.Value === ExecutionState.PreScheduled) && execNode.AssignmentCount === 0) {
                        if (name === "generate")
                            return true;
                        //if (name === "finishExecution")// nur für das Testen der Aktion, eigentlich nur in Scheduled Fall sichtbar
                        //    return true;
                    }
                    if ((execNode.ExecutionState.Value === ExecutionState.Scheduled || execNode.ExecutionState.Value === ExecutionState.PartialScheduled)) {
                        if (name === "finishExecution")
                            return true;
                        //if (execNode.AssignmentCount === 0 && name === "rescheduleExecution")
                        //    return true;
                    }
                    if ((execNode.ExecutionState.Value !== ExecutionState.Cancelled &&
                        this.props.entity.Executions.length === execNode.ExecutionNo &&
                        this.props.entity.Task.ExplicitProps.State.Value !== TaskState.Cancelled &&
                        this.props.entity.Task.ExplicitProps.State.Value !== TaskState.Finished))
                        if (name === "deleteExecution")
                            return true;
                }
                if (node.Type === ExecutionItemType.Assignment) {
                    let assignmentNode = (node as AssignmentNode);
                    if (assignmentNode.parentExecutionState != null && (assignmentNode.parentExecutionState == ExecutionState.Finished || assignmentNode.parentExecutionState == ExecutionState.Cancelled))
                        return false;
                    if (name === "rescheduleAssignment" || name === "deleteAssignment")
                        return true
                }
            }
        }

    }
    
    openExecutionErrors = async (executionId) => {
        let result = await Promise.all([HTTPService.get<JsonResultClass<TriggeringErrorListEntity>>('Executions/Errors?executionId=' + executionId), Helper.getMetaData("executionErrors")]);
        
        const entity = result[0];

        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
            return;
        }

        const sheet = General.Sheet.Manager.createSheet();

        const props: TriggeringErrorListAppProps = {
            context: {
                key1: "entity.Id",
                keyVal1: executionId,
                contextType: "executionErrors"
            },
            entity: entity.Data,
            metadata: result[1],
            dataSources: {},
            isWindow: false,
            doResetAll: async (): Promise<boolean> => { return await this.resetErrors(executionId) }
        };

        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.reloadTreeData();
        });
        sheet.bind(SheetEventType.ItemDeleted, () => {
            this.reloadTreeData();
        });
        sheet.show(() => {
            sheet.mountContent(TriggeringErrorListApp, props);
        });
        
    }
    
    // noinspection JSUnusedGlobalSymbols
    renderRecurringTaskHistory = () => {
        return (
            <div className="execution_treeview">
                <div className="flex-container flex-container__item ">
                    <div className="tree" style={{
                        width: "50%",
                        minWidth: "600px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}>
                        <Tree ref={(r) => {
                            this.treeRef = r
                        }}
                              tree={this.getRecurringTaskRoot()}
                              isChangeAllowed={this.isChangeAllowed}
                              noderRenderer={this.contentRenderer}
                              rightContentRenderer={this.rightContentRenderer}
                              afterSelect={this.handleSelect}
                              canBeSelected={this.isSelectAllowed}
                              canNotDrag={true}
                              commands={{
                                  canShow: (type: ToolBoxCommand, node: SortableTreeNode, name?: string) => {
                                      return this.canShowCommand(type, node as TreeLineItem, name);
                                  },
                                  custom: [
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.SkipExecution"),
                                          iconName: "times",
                                          name: "cancel",
                                          onClick: (cmd, node: ExecutionNode) => {
                                              //Cancel Dialoge Action
                                              let dialogDate = null;
                                              if (node != null)
                                                  dialogDate = node.ExecutionDate;
                                              this.setState({SelectedNode: node, DialogDate: dialogDate});
                                              this.cancelDialogRef.openDialog();
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CustomizeDueDate"),
                                          iconName: "reply",
                                          name: "rescheduleExecution",
                                          onClick: (cmd, node: ExecutionNode) => {
                                              //Reschedule Dialoge Action
                                              let dialogDate = null;
                                              if (node != null)
                                                  dialogDate = node.ExecutionDate;
                                              this.setState({SelectedNode: node, DialogDate: dialogDate});
                                              this.rescheduleDialogRef.openDialog();
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConfirmAsCompleted"),
                                          iconName: "flag-checkered",
                                          name: "finishExecution",
                                          onClick: (cmd, node: ExecutionNode) => {
                                              //Finish Dialoge Action 
                                              let dialogDate = null;
                                              if (node != null)
                                                  dialogDate = node.ExecutionDate;
                                              this.setState({SelectedNode: node, DialogDate: dialogDate});
                                              this.finishDialogRef.openDialog();
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteExecution"),
                                          iconName: "trash",
                                          name: "deleteExecution",
                                          onClick: (cmd, node: ExecutionNode) => {
                                              this.deleteExecution(node);
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CreateAssignments"),
                                          iconName: "random",
                                          name: "generate",
                                          onClick: (cmd, node: ExecutionNode) => {
                                              this.generateAssignments(node);
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteAssignment"),
                                          iconName: "trash",
                                          name: "deleteAssignment",
                                          onClick: (cmd, node: AssignmentNode) => {
                                              this.deleteAssignment(node);
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.Executions.ShowErrors"),
                                          iconName: "calendar-exclamation",
                                          name: "showErrors",
                                          onClick: (cmd, node: AssignmentNode) => {
                                              this.openExecutionErrors(node.ExecutionId);
                                          }
                                      },
                                      {
                                          hint: Helper.getTranslation("WebCRM.Tasks.Executions.ResetErrors"),
                                          iconName: "broom",
                                          name: "resetErrors",
                                          onClick: (cmd, node: AssignmentNode) => {
                                              this.resetErrors(node.ExecutionId);
                                          }
                                      }
                                  ]
                              }}
                        />
                    </div>
                </div>
            </div>
        )
    }
        
    private resetErrors = async (executionId: string): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem>>("Executions/ResetErrors", {
            executionId: executionId
        });
        if (result.Code === 0) {
            let copyTree = JSON.parse(JSON.stringify(this.state.TreeView));
            let index = Helper.findIndex(copyTree, "ExecutionId", executionId);
            copyTree[index] = this.FillExecutionNode(result.Data);
            copyTree[index].collapsed = this.state.TreeView[index].collapsed;
            for (let i = 0; i < copyTree[index].children.length; ++i) {
                copyTree[index].children[i].collapsed = this.state.TreeView[index].children[i].collapsed;
            }

            this.setSheetCommand("resetErrors");
            this.setState({TreeView: copyTree}, () => {
                this.treeRef.refresh(() => {
                    this.treeRef.select(copyTree[index]);
                });
            });
            return true;
        } else {
            NotificationHelper.showErrorMessage(result.Message);
            return false;
        }
    }
    
    private deleteAssignment = async (node: AssignmentNode) => {
        let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem>>('ResourcePlanning/DeleteAssignment?projNr=' + encodeURIComponent(node.ProjectNo) + '&pIndex=' + node.Pindex)
        if (result.Code === 0) {
            this.reloadTreeData();
        } else {
            NotificationHelper.showErrorResult(result);
        }
    }

    private reloadTreeData = async () => {
        let result = await HTTPService.get('RecurrencePlan/Init?taskId=' + this.props.entity.RecurrencePlan.TaskId);
        this.setState({TreeView: this.getRecurringTask(result.Data.Executions)}, () => {
            this.treeRef.refresh();
        });
    }

    private generateAssignments = async (node: ExecutionNode) => {
        //nur Execution Id 
        let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem>>("Executions/GenerateAssignments", {
            executionId: node.ExecutionId
        });
        if (result.Code !== 0) {
            this.onActionFailed("generateAssignments");
            NotificationHelper.showErrorMessage(result.Message);
        }
        if (result.Data != null) {
            let copyTree: Array<ExecutionNode> = JSON.parse(JSON.stringify(this.state.TreeView));
            let index = Helper.findIndex(copyTree, "ExecutionId", node.ExecutionId);
            copyTree[index] = this.FillExecutionNode(result.Data);
            copyTree[index].collapsed = this.state.TreeView[index].collapsed;
            this.setState({TreeView: copyTree}, () => {
                this.treeRef.refresh(() => {
                    this.treeRef.select(copyTree[index]);
                });
            });
        }
    }

    private cancelExecution = async (node) => {
        let result = await HTTPService.post<JsonResultClass<ExecutionInfoItem>>("Executions/CancelExecution", {
            executionId: node.ExecutionId,
            comment: this.state.DialogText
        });
        if (result.Code === 0) {
            let copyTree = JSON.parse(JSON.stringify(this.state.TreeView));
            let index = Helper.findIndex(copyTree, "ExecutionId", node.ExecutionId);
            copyTree[index] = this.FillExecutionNode(result.Data);
            copyTree[index].collapsed = this.state.TreeView[index].collapsed;
            for (let i = 0; i < copyTree[index].children.length; ++i) {
                copyTree[index].children[i].collapsed = this.state.TreeView[index].children[i].collapsed;
            }

            this.setSheetCommand("cancelExecution");
            this.setState({TreeView: copyTree}, () => {
                this.treeRef.refresh(() => {
                    this.treeRef.select(copyTree[index]);
                });
            });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private finishExecution = async (node) => {
        let result = await HTTPService.post<JsonResultClass<any>>("Executions/FinishExecution", {
            executionId: node.ExecutionId,
            comment: this.state.DialogText,
            finishDateTime: this.state.DialogDate
        });
        if (result.Code === 0) {
            let copyTree = JSON.parse(JSON.stringify(this.state.TreeView));
            var index = Helper.findIndex(copyTree, "ExecutionId", node.ExecutionId);
            copyTree[index] = this.FillExecutionNode(result.Data);
            copyTree[index].collapsed = this.state.TreeView[index].collapsed;
            for (let i = 0; i < copyTree[index].children.length; ++i) {
                copyTree[index].children[i].collapsed = this.state.TreeView[index].children[i].collapsed;
            }

            this.setSheetCommand("finishExecution");
            this.setState({TreeView: copyTree}, () => {
                this.treeRef.refresh(() => {
                    this.treeRef.select(copyTree[index]);
                });
            });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private rescheduleExecution = async (node) => {
        let result = await HTTPService.post<JsonResultClass<any>>("Executions/RescheduleExecution", {
            executionId: node.ExecutionId,
            comment: this.state.DialogText,
            rescheduleDateTime: this.state.DialogDate
        });
        if (result.Code === 0) {
            let copyTree = JSON.parse(JSON.stringify(this.state.TreeView));
            var index = Helper.findIndex(copyTree, "ExecutionId", node.ExecutionId);
            copyTree[index] = this.FillExecutionNode(result.Data);
            copyTree[index].collapsed = this.state.TreeView[index].collapsed;
            for (let i = 0; i < copyTree[index].children.length; ++i) {
                copyTree[index].children[i].collapsed = this.state.TreeView[index].children[i].collapsed;
            }

            this.setState({TreeView: copyTree}, () => {
                this.treeRef.refresh(() => {
                    this.treeRef.select(copyTree[index]);
                });
            });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    
    // noinspection JSUnusedGlobalSymbols
    public generateExecution = async () => {
        let result = await HTTPService.post<JsonResultClass<TriggeredExecutionEntity>>("TriggerExecution/TriggerNextExecution", {
            taskId: this.props.entity.RecurrencePlan.TaskId
        });
        if (result.Code === 0) {
            let copyTree = JSON.parse(JSON.stringify(this.state.TreeView));
            if (result.Data.TriggeredExecution != null) {
                copyTree.push(this.FillExecutionNode(result.Data.TriggeredExecution));
            }
            this.updateEntity(copyTree, result.Data.Plan);

            this.triggerNextExecution();
            this.setState({TreeView: copyTree}, () => {
                this.treeRef.refresh(() => {
                });
            });
        } else {
            this.onActionFailed("triggerNextExecution");
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    public deleteExecution = async (node: ExecutionInfoItem) => {
        let isOk = await DialogHelper.confirm(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteExecution.DeleteMessage") + Config.translations.deleteMessage);

        if (isOk) {
            let result = await HTTPService.post<JsonResultClass<RecurringTaskHistoryEntity>>("Executions/DeleteExecution",
                {executionId: node.ExecutionId, taskId: this.props.entity.Task.Id});

            if (result.Code === 0) {
                this.updateEntity(result.Data.Executions, result.Data.RecurrencePlan);
                this.reloadTreeData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private onActionFailed = (action: string) => {
        if(Helper.hasValue(this.props.onActionFailed))
            this.props.onActionFailed(action);
    }

    private updateEntity = (items: ExecutionInfoItem[] = null, plan: RecurrencePlanEntity = null, task: RecurringTaskEntity = null) => {
        let copyEntity: RecurringTaskHistoryEntity = JSON.parse(JSON.stringify(this.props.entity));
        if (items !== undefined && items !== null)
            copyEntity.Executions = items;
        if (plan !== undefined && plan !== null)
            copyEntity.RecurrencePlan = plan;
        if (task !== undefined && task !== null)
            copyEntity.Task = task;
        Helper.updateEntity(this.props.entity, copyEntity);
    }

    private triggerNextExecution = () => {
        this.sheet.trigger(SheetEventType.Custom, {command: "triggerNextExecution"});
    }
    private setSheetCommand = (command: string) => {
        this.sheet.trigger(SheetEventType.Custom, {command: command});
    }
    private isChangeAllowed = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            resolve(false);
        });
    }
    private formateTime = (minutes) => {
        let hour = Math.floor(minutes / 60);
        let hourstr = hour.toString();
        minutes = minutes - (hour * 60);
        let minutestr = this.getStringPartsForTimeFormat(minutes);
        if (minutes > 0) {
            return hourstr + ':' + minutestr + ' ' + Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Std");
        } else {
            return hourstr + ' ' + Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Std");
        }

    }
    private getStringPartsForTimeFormat = (value) => {
        let strPart = value.toString();
        if (strPart.length == 1) {
            strPart = '0' + strPart;
        }
        return strPart;
    }
    
     
    
    private getTextAssignmentCapaComparison = (capas: Array<CapacityRequirementEntity>, assignments: Array<AssignmentInfoItem>) => {
        let textLst = [];
        let styleDiv: React.CSSProperties = {
            marginBottom: "3px"
        };
        
        let assignmentsLeft = [...assignments];
        let capaOverviews: Array<CapaOverview> = [];
        
        capas.filter(c => !c.IsGroup).forEach(capa => {
            let capaOverview = capaOverviews.find(co => !co.IsContainer && co.RessNr == capa.ResNo);
            if (!capaOverview) {
                capaOverview = {
                    IsContainer: false,
                    GrNr: capa.GrNr,
                    GrName: capa.Bezeichnung,
                    RessNr: capa.ResNo,
                    RessName: capa.Vorname + " " + capa.Name,
                    plannedHours: 0,
                    durationInMinutes: 0
                };
                capaOverviews.push(capaOverview);
            }
            capaOverview.plannedHours += capa.Hours * capa.Count;

            let assignmentsOfResource = assignmentsLeft.filter(a => a.RessNo == capaOverview.RessNr);
            capaOverview.durationInMinutes += assignmentsOfResource.reduce((i, c) => { return i + c.CapacityInMinutes}, 0);
            assignmentsLeft = assignmentsLeft.filter(a => a.RessNo != capaOverview.RessNr);
        });

        capas.filter(c => c.IsGroup).forEach(capa => {
            let capaOverview = capaOverviews.find(co => co.IsContainer && co.GrNr == capa.GrNr);
            if (!capaOverview) {
                capaOverview = {
                    IsContainer: true,
                    GrNr: capa.GrNr,
                    GrName: capa.Bezeichnung,
                    RessNr: null,
                    RessName: null,
                    plannedHours: 0,
                    durationInMinutes: 0
                };
                capaOverviews.push(capaOverview);
            }
            capaOverview.plannedHours += capa.Hours * capa.Count;

            let assignmentsOfGroup = assignmentsLeft.filter(a => a.GroupNo == capaOverview.GrNr);
            capaOverview.durationInMinutes += assignmentsOfGroup.reduce((i, c) => { return i + c.CapacityInMinutes}, 0);
            assignmentsLeft = assignmentsLeft.filter(a => a.GroupNo != capaOverview.GrNr);
        });
        
        assignmentsLeft.forEach(assignmentLeft => {
            let capaOverview = capaOverviews.find(co => co.IsContainer && co.GrNr == assignmentLeft.GroupNo);
            if (!capaOverview) {
                capaOverview = {
                    IsContainer: true,
                    GrNr: assignmentLeft.GroupNo,
                    GrName: assignmentLeft.GroupName,
                    RessNr: null,
                    RessName: null,
                    plannedHours: 0,
                    durationInMinutes: 0
                };
                capaOverviews.push(capaOverview);
            }

            capaOverview.durationInMinutes += assignmentLeft.CapacityInMinutes;
        });
        
        capaOverviews.forEach(capa => {
            let durationInMinutes = capa.durationInMinutes;
            if (capa.IsContainer) {
                let params = {
                    of: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Of"),
                    plannedHours: this.formateTime(capa.plannedHours * 60),
                    durationInMinutes: this.formateTime(durationInMinutes),
                    capTitle: capa.GrName
                }
                textLst.push(<React.Fragment key={kendo.guid()}>
                    <div
                        style={styleDiv}> {Helper.formatString("{durationInMinutes} {of} {plannedHours} {capTitle}", params)} </div>
                </React.Fragment>)
            } else {
                let plannedHoursStr = this.formateTime(capa.plannedHours * 60);
                let durationInMinutesStr = this.formateTime(durationInMinutes);
                let params = {
                    of: Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Of"),
                    plannedHours: plannedHoursStr,
                    durationInMinutes: durationInMinutesStr,
                    capTitle: capa.RessName
                }
                textLst.push(<React.Fragment key={kendo.guid()}>
                    <div style={styleDiv}
                         key={kendo.guid()}> {Helper.formatString("{durationInMinutes} {of} {plannedHours} {capTitle}", params)} </div>
                </React.Fragment>)
            }
        });
        return (textLst);
    }

    private renderExecution = (node: ExecutionNode) => {
        let CssStyleDiv: React.CSSProperties = {
            marginBottom: "3px"
        };
        let params = {
            von: Helper.hasValue(node.StartMin) ? kendo.toString(kendo.parseDate(node.StartMin), 'd') : null,
            bis: Helper.hasValue(node.EndMax) ? kendo.toString(kendo.parseDate(node.EndMax), 'd') : null
        };

        let stateStyle: React.CSSProperties = {};
        let executionDate = kendo.parseDate(node.ExecutionDate);
        let stateDate = kendo.parseDate(node.StateDate);
        if (Helper.hasValue(stateDate)) {
            if ((Helper.hasValue(node.EndMax) && kendo.parseDate(node.EndMax) < stateDate) ||
                (Helper.hasValue(node.StartMin) && kendo.parseDate(node.StartMin) > stateDate)) {
                stateStyle = {
                    backgroundColor: '#f5d9e3'
                };
            }
        }

        let toleranceText = (params.von != null && params.bis != null ? Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.FromTo").replace("{from}", params.von).replace("{to}", params.bis) :
            (params.von != null) ? Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.NotBefore").replace("{date}", params.von) :
                (params.bis != null) ? Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.NotAfter").replace("{date}", params.bis) : null);
        let tolerance = (Helper.hasValue(toleranceText) ? (
            <div style={CssStyleDiv}>
                <span style={stateStyle}>{toleranceText}</span>
            </div>) : null);
        let iconIsScheduled = (node.IsScheduled ? <div style={{display: "inline-flex"}}><i className="far fa-clock"></i></div> : null);
        let iconErrors = (node.ErrorCount > 0 ? <div style={{ display: "inline-flex" }}><i className="far fa-calendar-exclamation" title={Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConflictGeneratingAssignment")}/></div>: null);

        let stateComp =
            <span title={node.StateToolTip} style={stateStyle}>
                {node.ExecutionState.Title} {Helper.hasValue(stateDate) && (stateDate.getTime() !== executionDate.getTime()) ? '(' + Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.On").replace("{date}", kendo.toString(stateDate, 'd')) + ')' : null}
            </span>;

        let assignmentCount = (node.AssignmentCount > 0) ?
            (<div style={CssStyleDiv}>
                {Helper.getTranslation("Standard.Einsaetze")}: {node.AssignmentCount}
            </div>) : null;
        let workPackageLink: string = "WorkPackage/Init?id=" + node.WorkPackageId;
        let schemaVersion = (node.SchemaVersion > 1)
            ? (<div
                style={CssStyleDiv}> {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.SchemaVersion")}: {node.SchemaVersion}</div>)
            : null;
        let capaCheck = (Helper.hasValue(node.Assignments) && Helper.hasValue(node.CapacityRequirements))
            ? this.getTextAssignmentCapaComparison(node.CapacityRequirements, node.Assignments)
            : null;
        let execParams = {
            executionNo: node.ExecutionNo,
            executionDate: Helper.hasValue(node.ExecutionDate) ? kendo.toString(executionDate, 'd') : null
        }
        let triggeredText = Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DueDate").replace("{count}", execParams.executionNo.toString()).replace("{date}", execParams.executionDate);
        return (
            <div className="item item-card">
                <div className="title" style={CssStyleDiv}>
                    {iconErrors} {triggeredText} {iconIsScheduled}&nbsp;/&nbsp;{stateComp}
                </div>
                {tolerance}
                <div style={{fontSize: "1em", marginBottom: "3px"}} className="subtitle">
                    <a onClick={() => {
                        this.openWorkPackage(workPackageLink)
                    }}> {node.WorkPackageTitle}</a>
                </div>
                {schemaVersion}
                {assignmentCount}
                {capaCheck}
            </div>);
    }
    private openAssignment = (url: string) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "reloadExecutionInfo") {
                this.reloadTreeData();
            }
        });

    }
    private openWorkPackage = async (url: string) => {
        let results = await Promise.all([HTTPService.get<JsonResultClass<WorkPackageEntity>>(url), Helper.getMetaData("workPackage")]);
        const entity = results[0].Data;
        entity.RecordRight.CanWrite = false;
        entity.taskEntity = { 
            Id: this.props.entity.Task.Id, 
            LockMessage: this.props.entity.Task.LockMessage,
            IsId: this.props.entity.Task.IsId};
        const metadata = results[1];
        const props: WorkPackageAppProps = {
            readOnly: true,
            context: {key1: "entity.Id", keyVal1: entity.Id, standAlone: false, contextType: "workPackage"},
            title: Helper.getTranslation("WebCRM.Tasks.Title.Workpackage"),
            entity: entity,
            metadata: metadata,
            dataSources: {},
            isWindow: false
        }

        const sheet = General.Sheet.Manager.createSheet();

        sheet.show(() => {
            sheet.mountContent(WorkPackageApp, props);
        });
    }
    private renderMachine = (node: MachineNode) => {

        return (
            <div className="item item-card">
                <div className="title" style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("WebCRM.Tasks.WorkPackage.Machine")}: {node.Bezeichnung}
                </div>
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("Field.fstasks.Machine.Maschnr")}: {node.MachineNo}
                </div>
                <div style={{fontSize: "1em", marginBottom: "3px"}} className="subtitle">
                    <a> {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.LinkMaschine")}</a>
                </div>

            </div>);
    }
    private renderAssignment = (node: AssignmentNode) => {
        let assignemtLink = Config.baseUrl + "ResourcePlanning/Edit?projNr=" + node.ProjectNo + "&pIndex=" + node.Pindex;
        const reportCount = (node.ReportCount > 0) ?
            (<div style={{marginBottom: "3px"}}>
                {Helper.getTranslation("WebSMS.Reporting.Reports")}: {node.ReportCount}
            </div>) : null;
        const serviceReportCount = (node.ServiceReportCount > 0) ?
            (<div style={{marginBottom: "3px"}}>
                {Helper.getTranslation("WebSMS.Title.Servicereports")}: {node.ServiceReportCount}
            </div>) : null;
        const containerAssignment = (node.IsContainerAssignment)
            ? (
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.WorklistAssignment")}: {node.GroupName}
                </div>)
            : null;
        const workStart = (node.DurationInDays > 1)
            ? kendo.toString(kendo.parseDate(node.WorkStart), 'd')
            : kendo.toString(kendo.parseDate(node.WorkStart), 'g');
        const workEnd = (node.DurationInDays > 1)
            ? kendo.toString(kendo.parseDate(node.WorkEnd), 'd')
            : kendo.toString(kendo.parseDate(node.WorkEnd), 't');
        return (
            <div className="item item-card">
                <div className="title" style={{marginBottom: "3px"}}>
                    {node.Name}
                </div>
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("Projekt.Projekt")}: {node.ProjectNo}
                </div>
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("Field.Einsatz.kennung")}: {node.Kennung}
                </div>
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DurationInDays")}: {node.DurationInDays}
                </div>
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Capacity")}: {this.formateTime(node.CapacityInMinutes)}
                </div>
                {containerAssignment}
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("Field.Projekt.status")}: {node.AssignmentState}
                </div>
                <div style={{marginBottom: "3px"}}>
                    {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.FromTo").replace("{from}", workStart).replace("{to}", workEnd)}
                </div>
                <div style={{fontSize: "1em", marginBottom: "3px"}} className="subtitle">
                    <a onClick={() => {
                        this.openAssignment(assignemtLink)
                    }}> {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.LinkAssignment")}</a>
                </div>
                {reportCount}
                {serviceReportCount}
            </div>);
    }
    private renderRootNode = (node) => {
        let CssStyleDiv: React.CSSProperties = {
            marginBottom: "3px"
        };

        let plan = this.props.entity.RecurrencePlan;

        let showStart = Helper.hasValue(plan?.StartsOn);
        let showEnd = Helper.hasValue(plan?.EndsOn);
        let showMaxExec = Helper.hasValue(plan?.MaxExecutions);
        let showExecutedTill = Helper.hasValue(plan?.ExecutedTill);

        let showState = Helper.hasValue(plan.State);
        let startsOn = showStart
            ? (
                <div style={CssStyleDiv}>
                    {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.StartsOn")} {kendo.toString(kendo.parseDate(plan.StartsOn), 'd')}
                </div>
            )
            : null;
        let endsOn = showEnd
            ? (
                <div style={CssStyleDiv}>
                    {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.EndsOn")} {kendo.toString(kendo.parseDate(plan.EndsOn), 'd')}
                </div>
            )
            : null;

        let planState = showState ? (<div
            style={CssStyleDiv}> {Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ExecutionPlan")}: {plan.State.Title}</div>) : null;

        let maxExecutions = showMaxExec
            ? (
                <div style={CssStyleDiv}>
                    {this.state.TreeView.length} / {plan?.MaxExecutions} {Helper.getTranslation("WebCRM.Tasks.RecurringTask.Executions")}
                </div>)
            : (
                <div style={CssStyleDiv}>
                    {this.state.TreeView.length}/ - {Helper.getTranslation("WebCRM.Tasks.RecurringTask.Executions")}
                </div>);
        let executedTill = showExecutedTill
            ? (
                <div style={CssStyleDiv}>
                    {Helper.getTranslation("WebCRM.Tasks.ExecuteAll.PlannedUntil")}: {kendo.toString(kendo.parseDate(plan?.ExecutedTill), 'd')}
                </div>)
            : null;
        return (
            <div className="item item-card">
                <div className="title" style={{marginBottom: "3px"}}>

                    <div> {node.Title}</div>
                    {maxExecutions}
                    {planState}
                    {startsOn}
                    {endsOn}
                    {executedTill}
                </div>
            </div>
        );
    }
    private contentRenderer = (node: TreeLineItem) => {

        if (node.Type == ExecutionItemType.Execution) {
            return (this.renderExecution(node as ExecutionNode));
        } else if (node.Type == ExecutionItemType.Assignment) {
            return (this.renderAssignment(node as AssignmentNode));
        } else if (node.Type === ExecutionItemType.Machine) {
            return (this.renderMachine(node as MachineNode));
        } else {
            return (this.renderRootNode(node as ExecutionNode));
        }
    }

    private rightContentRenderer = () => {
        return null;
    }

    private handleSelect = () => {
    }

    private isSelectAllowed = () => {
        return new Promise<boolean>((resolve) => {
            resolve(true);
        });
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {

        }


        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    getExecutionDialog = (label: string, showDatePicker: boolean, onDialogOk: () => void, setDialogRef: (ref) => void, comment: string = null, datePickerText: string = null) => {
        var executionDialogTitle = "";
        var selectedNode: ExecutionNode = this.state.SelectedNode as ExecutionNode;
        if (Helper.hasValue(selectedNode))
            executionDialogTitle = selectedNode.ExecutionNo.toString() + ' ' + selectedNode.WorkPackageTitle;
        return <ExecutionDialog
            title={executionDialogTitle}
            label={label}
            textBoxValue={this.state.DialogText}
            onTextBoxChange={(value: string) => {
                this.setState({DialogText: value})
            }}
            showDatePicker={showDatePicker}
            dateValue={this.state.DialogDate}
            onDateChange={(value: string) => {
                this.setState({DialogDate: value})
            }}
            onDialogOk={onDialogOk}
            ref={setDialogRef}
            translations={this.translations}
            comment={comment}
            datePickerText={datePickerText}/>
    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), {handleFieldChange: this.handleFieldChange});
        const titleProps: PageTitleProps = {
            title: this.props.title,
            locked: Helper.hasValue(this.props.entity.Task.LockMessage) && this.props.entity.Task.LockMessage.trim() !== "",
            lockInfo: this.props.entity.Task.LockMessage
        };

        const cancelDialog = this.getExecutionDialog(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.SkipExecution"), false, () => this.cancelExecution(this.state.SelectedNode), (ref) => {
            this.cancelDialogRef = ref
        }, Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.DeleteAllAssignments"));
        const finishDialog = this.getExecutionDialog(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConfirmAsCompleted"), true, () => this.finishExecution(this.state.SelectedNode), (ref) => {
            this.finishDialogRef = ref
        }, null, Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.ConfirmAsCompletedFor"));
        const rescheduleDialog = this.getExecutionDialog(Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CustomizeDueDate"), true, () => this.rescheduleExecution(this.state.SelectedNode), (ref) => {
            this.rescheduleDialogRef = ref
        }, null, Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.CustomizeDueDateTo"));


        return (<>
            {cancelDialog}
            {finishDialog}
            {rescheduleDialog}
            <CommonApp{...props} titleProps={titleProps}/>

        </>);
    }
}

interface RecurringTaskRoot {
    Title: string;
    children: Array<ExecutionTreeNode>
}

interface ExecutionTreeNode {
    Type: ExecutionItemType;
    collapsed?: boolean;
    children: Array<ExecutionTreeNode>
}

interface ExecutionNode extends ExecutionTreeNode, ExecutionInfoItem {
}

interface MachineNode extends ExecutionTreeNode, MachineInfoItem {
}

interface AssignmentNode extends ExecutionTreeNode, AssignmentInfoItem {
    parentExecutionState?: ExecutionState;
}

export interface ExecutionInfoItem {
    ExecutionId?: string;
    ExecutionNo?: number;
    ExecutedTill?: string;
    ExecutionDate?: string;
    IsScheduled?: boolean;
    IsLastExecution?: boolean;

    // Toleranzen
    StartMin?: string;
    EndMax?: string;
    FonCli
    WorkPackageId?: string;
    WorkPackageTitle?: string;

    AssignmentCount?: number;

    SchemaVersion?: number;
    CapaityRequirementsLoaded?: boolean;
    CapacityRequirements?: Array<CapacityRequirementEntity>;

    ExecutionState?: EnumEntity<ExecutionState>; //  ExecutionState;

    StateDate?: string;
    StateToolTip?: string;

    TaskVm?: RecurringTaskInfo;

    AssignmentsLoaded?: boolean;
    Assignments?: Array<AssignmentInfoItem>;
    MachinesLoaded?: boolean;
    Machines?: Array<MachineInfoItem>;
    ErrorCount: number;
}

interface MachineInfoItem {
    MachineNo?: string;
    Bezeichnung?: string;
    //...
}

export interface AssignmentInfoItem {
    Name?: string;
    ProjectNo?: string;
    Pindex?: number;
    Kennung?: string;
    WorkStart?: string;
    WorkEnd?: string;

    AssignmentState?: string;
    AssignmentStateType?: AssignmentState;// eventuell Aktionen ein bzw ausblenden
    ReportCount?: number;
    ServiceReportCount?: number;

    DurationInDays?: number;
    CapacityInMinutes?: number;
    IsContainerAssignment?: boolean;
    GroupNo?: number;
    RessNo?: string;
    RessName?: string;

    Bemerkung?: string;

    GroupName?: string;
    AdrNr?: string;
    AdrName?: string;
    TaskId?: string;
    TaskNo?: string;
    ExecutionId?: string;
    ExecutionNo?: number;
    ParentExecutionState?: EnumEntity<ExecutionState>;
}

interface CapaOverview {
    IsContainer: boolean;
    GrNr: number;
    GrName: string;
    RessNr: string;
    RessName: string;
    plannedHours: number;
    durationInMinutes: number;
}

interface RecurringTaskHistoryState {
    DialogText: string;
    DialogDate?: string;

    TreeView?: Array<ExecutionTreeNode>;
    SelectedNode?: ExecutionTreeNode;
}

export interface RecurringTaskHistoryProps extends AppBaseProps {
    entity: RecurringTaskHistoryEntity;
    onActionFailed?: (action: string) => void;
}

export interface RecurrencePlanEntity {
    TaskId: string;
    State: EnumEntity<PlanState>;
    StartsOn: string;
    EndsOn: string;
    MaxExecutions: number;
    ExecutedTill: string;
}

export interface RecurringTaskHistoryEntity extends Entity {
    RecurrencePlan: RecurrencePlanEntity;
    Executions: Array<ExecutionInfoItem>;
    Task: RecurringTaskEntity;
}

export interface TriggeredExecutionEntity {
    Plan: RecurrencePlanEntity;
    TriggeredExecution: ExecutionInfoItem;
}

enum PlanState {
    Draft,
    Initialized,
    Finished,
    Cancelled
}

enum ExecutionItemType {
    Execution,
    SubElementType,
    Assignment,
    Machine
}

export enum ExecutionState {
    Triggered,
    PreScheduled,
    Scheduled,
    PartialScheduled,
    Finished,
    Cancelled
}

enum AssignmentState {
    Scheduled,
    PrePlanned,
    Executed,
    Finished
}

export type TreeLineItem = ExecutionTreeNode;